export default __webpack_public_path__ + "static/media/IMG_20210202_192511~2 - URJA JAIN.00eabe21.jpg";